import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TProgramViewedPlaces } from '../types';

export const getProgramsViewedPlaces = async (): Promise<TProgramViewedPlaces[]> => {
  return mediaManagerClient.get('/api/v1/program_viewed_places').then(({ data }) => data);
};
type QueryFnType = typeof getProgramsViewedPlaces;

type UseProgramsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetProgramsViewedPlaces = ({ config }: UseProgramsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['program-viewed-places'],
    queryFn: getProgramsViewedPlaces,
  });
};
